import { Component, OnInit } from '@angular/core';
import { ApiKeys } from '../shared/constants'

@Component({
  selector: 'app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  ngOnInit() {
    this.initMapScript()
  }

  private initMapScript() {
    const script = document.getElementById('mapScript') as HTMLScriptElement
    script.src = `https://maps.googleapis.com/maps/api/js?key=${ApiKeys.GOOGLE_MAPS}&libraries=drawing,places&v=3.64`
  }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts